import Spinner from '@v2/shared/components/Spinner';

/**
 * Laid over the buy column while a sticky offer's prices load — headless_jshop's own
 * ActivatingOffer. It covers the buttons as well as the price: an Add to Cart pressed in
 * that window would go without the code, at the price the page is about to take back.
 */
export default function ActivatingOffer() {
  return (
    <div className="absolute inset-0 z-10 flex items-center justify-center">
      <div className="absolute inset-0 bg-black opacity-30" />
      <div role="status" className="relative bg-slate-100 border border-slate-200 rounded p-4">
        <Spinner className="text-2xl mr-2" />
        Activating offer...
      </div>
    </div>
  );
}
